import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface SideMenuState {
  isExpanded: boolean;
  isMobileMenuOpen: boolean;
}

/**
 * The rail opens collapsed (CTX-639): its Account section moved to the header's
 * settings control, so the nav no longer has to be read to reach those rows —
 * and a collapsed rail gives the content ~160px back.
 *
 * Only `isExpanded` is persisted, by a nested persist config in the store.
 * `isMobileMenuOpen` must not survive a reload: a drawer that reopens itself is
 * a bug, not a remembered preference.
 */
const initialState: SideMenuState = {
  isExpanded: false,
  isMobileMenuOpen: false,
};

const sideMenuSlice = createSlice({
  name: "sideMenu",
  initialState,
  reducers: {
    toggleMenu: (state) => {
      state.isExpanded = !state.isExpanded;
    },
    setMenuExpanded: (state, action: PayloadAction<boolean>) => {
      state.isExpanded = action.payload;
    },
    toggleMobileMenu: (state) => {
      state.isMobileMenuOpen = !state.isMobileMenuOpen;
    },
    setMobileMenuOpen: (state, action: PayloadAction<boolean>) => {
      state.isMobileMenuOpen = action.payload;
    },
  },
});

// Exportamos las acciones
export const { toggleMenu, setMenuExpanded, toggleMobileMenu, setMobileMenuOpen } = sideMenuSlice.actions;

// Exportamos el reducer por defecto
export default sideMenuSlice.reducer;
